<template>
    <div>
        <el-row :gutter='30'>
            <el-col :span='12'>
                <el-button style='float: left; padding: 3px 0' @click='reset()' type='text'>重置查询</el-button>
                <el-button style='float: left; padding: 3px 0' icon='el-icon-upload2' size='mini' type='text'
                           @click='handleOpenExport'>数据导出
                </el-button>
                <el-button :disabled='!chartData.chartLoadingStatus' style='float: left; padding: 3px 0'
                           @click='refreshCache' type='text'>刷新缓存
                </el-button>
            </el-col>
            <el-col :span='12'>
                <el-date-picker
                    v-if='showTimePicker'
                    v-model='timePicker.pickerTimeValue'
                    type='datetimerange'
                    align='right'
                    unlink-panels
                    range-separator='至'
                    start-placeholder='开始日期'
                    end-placeholder='结束日期'
                    value-format='yyyy-MM-dd HH:mm:ss'
                    @blur='handleTimePickerBlur'
                    :picker-options='timePicker.pickerOptions'>
                </el-date-picker>
            </el-col>
        </el-row>
        <el-skeleton :rows='10' animated :loading='!chartData.chartLoadingStatus'>
            <cotton-echarts style='margin-bottom: 1rem;' v-for='(item, index) in chartData.chartOptionList' :key='index'
                            :loading='chartData.chartLoadingStatus'
                            :show-card-header='true'
                            :show-label-switch='true'
                            :chart-option='item'>
                <template #echarts-header>
                    <div v-if='item.cottonCustomConfig.chartType === "pie" && item.cottonCustomConfig.isTwoDimension'>
                        <el-row :gutter='10'>
                            <el-col :span='12'>
                                <el-switch
                                    v-model='item.cottonCustomConfig.showOnePieChart'
                                    :active-text='computeOnePieSwitchLabel(item.cottonCustomConfig)'>
                                </el-switch>
                            </el-col>
                            <el-col v-if='item.cottonCustomConfig.showOnePieChart' :span='12'>
                                <span style='font-size: 14px'>子扇形大小&nbsp;&nbsp;</span>
                                <el-input-number size='mini' v-model='customMultiPieConfig.counter'
                                                 @change='handleChangeMultiPieSize($event, item)' :min='0'
                                                 :max='10'></el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                </template>
                <template #echarts-bottom>
                    <el-row style='margin-top: 1rem;'
                            v-if='item.cottonCustomConfig.chartType === "pie" && item.cottonCustomConfig.isTwoDimension && item.cottonCustomConfig.showOnePieChart'
                            :gutter='10'>
                        <el-col v-for='(sonPieChart, sonIndex) in item.cottonCustomConfig.twoDimensionPieChartList'
                                :key='sonIndex'
                                :span='customMultiPieConfig.colSpanNum'>
                            <cotton-echarts style='margin-bottom: 1rem;' :key='`${index}${sonIndex}`'
                                            :loading='chartData.chartLoadingStatus'
                                            :show-card-header='false'
                                            :height='customMultiPieConfig.chartHeight'
                                            :chart-option='sonPieChart'></cotton-echarts>
                        </el-col>
                    </el-row>
                </template>
            </cotton-echarts>
        </el-skeleton>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { trackEventAnalyseApi } from '@api/Track/trackEventAnalyse';
import { message } from '@/utils/message';
import { cloneDeep } from 'lodash';
import { deepCopy } from '@/utils/object';
import { trackReportSettingApi } from '@api/Track/trackReportSetting';
import { exportTrackDataApi } from '@api/Track/exportTrackData';
import { notification } from '@/utils/notification';

export default defineComponent({
    name: 'TrackEventChart',
    props: {
        eventId: {
            type: String
        },
        trackReportSettingId: {
            type: String
        },
        projectAppId: {
            type: String
        },
        trackReportSettingJson: {
            type: String,
            default: ''
        },
        showTimePicker: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            convertData: {
                trackReportSettingId: undefined,
                trackReportSettingJson: undefined
            },
            queryParams: {
                trackReportSettingId: undefined,
                startTime: undefined,
                endTime: undefined,
                projectAppId: undefined
            },
            trackReportSetting: {},
            reportChartResult: {},
            chartData: {
                chartOptionList: [],
                chartLoadingStatus: false,
                chartTemplateOption: {
                    title: {
                        text: ''
                    },
                    legend: {
                        type: 'scroll',
                        orient: 'vertical',
                        right: 10,
                        top: 20,
                        bottom: 20,
                        data: []
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params, ticket, callback) => {
                            if (!params || params.length === 0) {
                                return '';
                            }
                            if (!params) {
                                return '';
                            }
                            let dimensionData = {};
                            try {
                                dimensionData = JSON.parse(params[0].data[0]);
                            } catch (e) {
                                console.error(e);
                                return '';
                            }
                            let dimensionLabel;
                            let viewResult;
                            let isTwoDimension = dimensionData.isTwoDimension;
                            if (isTwoDimension) {
                                // 二维
                                viewResult = `<p><span style='color: #409EFF; font-weight: bold;'>${dimensionData.oneDimensionTitle}: ${dimensionData.oneDimensionLabel}</span><p style='padding-left: 1rem;'><span style='color: #409EFF; font-weight: bold;'>${dimensionData.twoDimensionTitle}: ${dimensionData.twoDimensionLabel}</span></p> 分组下的数据详情</p>`;
                            } else {
                                dimensionLabel = `${dimensionData.twoDimensionLabel}`;
                                viewResult = `<p><span style='color: #409EFF; font-weight: bold;'>${dimensionLabel}</span> 分组下的数据详情</p>`;
                            }
                            params.forEach((item, index) => {
                                let marker = item.marker;
                                let data = item.data;
                                let seriesName = item.seriesName;
                                if (seriesName === 'oneDimension') {
                                    return;
                                }
                                let metricLabel = data[1];
                                let lineShow = '<p>' + marker + '&nbsp;' + `${seriesName}: <span style='color: #409EFF'>${metricLabel}</span> ` + '</p>';
                                viewResult = viewResult + lineShow;
                            });
                            
                            return viewResult
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {
                                show: true,
                                excludeComponents: ['toolbox'],
                                pixelRatio: 2
                            }
                        }
                    },
                    dataset: [],
                    dataZoom: [
                        {
                            type: 'inside'
                        }
                    ],
                    xAxis: [
                        {
                            id: '0',
                            type: 'category',
                            axisLabel: {
                                interval: 'auto',
                                rotate: 0,
                                inside: false,
                                formatter: (value, index) => {
                                    let dimensionData;
                                    try {
                                        dimensionData = JSON.parse(value);
                                    } catch (e) {
                                        return value;
                                    }
                                    return dimensionData.twoDimensionLabel;
                                }
                            },
                            axisTick: {
                                length: 15,
                                show: true,
                                inside: false,
                                lineStyle: {
                                    color: '#409EFF'
                                },
                                interval: function(index, value) {
                                    let dimensionSetting;
                                    try {
                                        dimensionSetting = JSON.parse(value);
                                    } catch (e) {
                                        return false;
                                    }
                                    if (!dimensionSetting) {
                                        return false;
                                    }
                                    return dimensionSetting.showAxisTick;
                                }
                            },
                            name: ''
                        },
                        {
                            id: 'oneDimension',
                            position: 'bottom',
                            offset: 60, // 向下偏移，为了不和第一条x轴重合
                            //x轴 轴线
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                interval: 'auto',
                                rotate: 0,
                                color: '#409EFF',
                                fontWeight: 'bolder',
                                fontSize: 9,
                                inside: true,
                                formatter: (value, index) => {
                                    let dimensionData;
                                    try {
                                        dimensionData = JSON.parse(value);
                                    } catch (e) {
                                        return value;
                                    }
                                    if (!dimensionData) {
                                        return;
                                    }
                                    let isShowDimensionLabel = dimensionData.isShowDimensionLabel;
                                    if (isShowDimensionLabel) {
                                        return dimensionData.showDimensionLabel;
                                    }
                                }
                            },
                            axisPointer: {
                                show: false
                            },
                            data: []
                        }
                    ],
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            interval: 'auto'
                        },
                        name: '',
                        position: 'left'
                    },
                    series: [{
                        type: 'line',
                        smooth: true,
                        encode: { x: 'dimensionLabel', y: 'metricLabel' },
                        datasetIndex: 1,
                        name: ''
                    }]
                },
                pieChartTemplateOption: {
                    title: {
                        text: ''
                    },
                    legend: {
                        type: 'scroll',
                        orient: 'vertical',
                        right: 10,
                        top: 20,
                        bottom: 20,
                        formatter: (name) => {
                            let dimensionData;
                            try {
                                dimensionData = JSON.parse(name);
                            } catch (e) {
                                console.error(e);
                                return '';
                            }
                            let isTwoDimension = dimensionData.isTwoDimension;
                            let dimensionLabel;
                            if (isTwoDimension) {
                                dimensionLabel = `${dimensionData.oneDimensionLabel} ${dimensionData.twoDimensionLabel}`;
                            } else {
                                dimensionLabel = `${dimensionData.twoDimensionLabel}`;
                            }
                            return dimensionLabel;
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: (params, ticket, callback) => {
                            let data = params.data;
                            if (!data || data.length === 0) {
                                return;
                            }
                            let metricLabel = data[1];
                            let percent = params.percent;
                            let seriesName = params.seriesName;
                            
                            let dimensionData = {};
                            try {
                                dimensionData = JSON.parse(data[0]);
                            } catch (e) {
                                console.error(e);
                                return '';
                            }
                            let isTwoDimension = dimensionData.isTwoDimension;
                            if (isTwoDimension) {
                                // 二维
                                return `<p><span style='color: #409EFF; font-weight: bold;'>${dimensionData.oneDimensionTitle}: ${dimensionData.oneDimensionLabel}</span><p style='padding-left: 1rem;'><span style='color: #409EFF; font-weight: bold;'>${dimensionData.twoDimensionTitle}: ${dimensionData.twoDimensionLabel}</span></p> 分组下的数据详情</p><p>${seriesName}: <span style='color: #409EFF'>${metricLabel}</span></p><p>占比: <span style='color: #409EFF'>${percent}%</span></p>`;
                            } else {
                                let dimensionLabel = `${dimensionData.twoDimensionLabel}`;
                                return `<p><span style='color: #409EFF; font-weight: bold;'>${dimensionLabel}</span> 分组下的数据详情</p><p>${seriesName}: <span style='color: #409EFF'>${metricLabel}</span></p><p>占比: <span style='color: #409EFF'>${percent}%</span></p>`;
                            }
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {
                                show: true,
                                excludeComponents: ['toolbox'],
                                pixelRatio: 2
                            }
                            
                        }
                    },
                    dataset: [],
                    dataZoom: [
                        {
                            type: 'inside',
                        }
                    ],
                    series: [
                        {
                            name: '',
                            type: 'pie',
                            radius: [50, 200],
                            center: ['50%', '50%'],
                            // roseType: 'area',
                            stillShowZeroSum: true,
                            itemStyle: {
                                borderRadius: 8
                            },
                            label: {
                                show: true,
                                position: 'outside',
                                formatter: (params) => {
                                    let dimensionData;
                                    try {
                                        dimensionData = JSON.parse(params.data[0]);
                                    } catch (e) {
                                        console.error(e);
                                        return '';
                                    }
                                    let isTwoDimension = dimensionData.isTwoDimension;
                                    let dimensionLabel;
                                    if (isTwoDimension) {
                                        dimensionLabel = `${dimensionData.oneDimensionLabel} ${dimensionData.twoDimensionLabel}`;
                                    } else {
                                        dimensionLabel = `${dimensionData.twoDimensionLabel}`;
                                    }
                                    let percent = params.percent;
                                    return `${dimensionLabel}  ${percent}%`;
                                }
                            },
                            encode: {
                                itemName: 'dimensionLabel',
                                value: 'metricLabel'
                            },
                            datasetIndex: 1
                        }
                    ]
                },
                twoDimensionPieChartTemplateOption: {
                    title: {
                        text: '',
                        show: true,
                        textStyle: {
                            fontSize: 12
                        }
                    },
                    legend: {
                        show: false,
                        type: 'scroll',
                        orient: 'vertical',
                        right: 10,
                        top: 20,
                        bottom: 20,
                        formatter: (name) => {
                            let dimensionData;
                            try {
                                dimensionData = JSON.parse(name);
                            } catch (e) {
                                console.error(e);
                                return '';
                            }
                            let isTwoDimension = dimensionData.isTwoDimension;
                            let dimensionLabel;
                            if (isTwoDimension) {
                                dimensionLabel = `${dimensionData.oneDimensionLabel} ${dimensionData.twoDimensionLabel}`;
                            } else {
                                dimensionLabel = `${dimensionData.twoDimensionLabel}`;
                            }
                            return dimensionLabel;
                        },
                        data: []
                    },
                    tooltip: {
                        trigger: 'item',
                        show: false,
                        formatter: (params, ticket, callback) => {
                            let data = params.data;
                            if (!data || data.length === 0) {
                                return;
                            }
                            let metricLabel = data[1];
                            let percent = params.percent;
                            let seriesName = params.seriesName;
                            
                            let dimensionData = {};
                            try {
                                dimensionData = JSON.parse(data[0]);
                            } catch (e) {
                                console.error(e);
                                return '';
                            }
                            let isTwoDimension = dimensionData.isTwoDimension;
                            if (isTwoDimension) {
                                // 二维
                                return `<p><span style='color: #409EFF; font-weight: bold;'>${dimensionData.oneDimensionTitle}: ${dimensionData.oneDimensionLabel}</span><p style='padding-left: 1rem;'><span style='color: #409EFF; font-weight: bold;'>${dimensionData.twoDimensionTitle}: ${dimensionData.twoDimensionLabel}</span></p> 分组下的数据详情</p><p>${seriesName}: <span style='color: #409EFF'>${metricLabel}</span></p><p>占比: <span style='color: #409EFF'>${percent}%</span></p>`;
                            } else {
                                let dimensionLabel = `${dimensionData.twoDimensionLabel}`;
                                return `<p><span style='color: #409EFF; font-weight: bold;'>${dimensionLabel}</span> 分组下的数据详情</p><p>${seriesName}: <span style='color: #409EFF'>${metricLabel}</span></p><p>占比: <span style='color: #409EFF'>${percent}%</span></p>`;
                            }
                        }
                    },
                    dataset: [],
                    dataZoom: [
                        {
                            type: 'inside'
                        }
                    ],
                    series: [
                        {
                            name: '',
                            type: 'pie',
                            radius: 40,
                            center: ['50%', '50%'],
                            // roseType: 'area',
                            stillShowZeroSum: true,
                            itemStyle: {
                                borderRadius: 8
                            },
                            label: {
                                show: true,
                                position: 'inside',
                                formatter: (params) => {
                                    let dimensionData;
                                    try {
                                        dimensionData = JSON.parse(params.data[0]);
                                    } catch (e) {
                                        console.error(e);
                                        return '';
                                    }
                                    let isTwoDimension = dimensionData.isTwoDimension;
                                    let dimensionLabel;
                                    if (isTwoDimension) {
                                        dimensionLabel = `${dimensionData.oneDimensionLabel} ${dimensionData.twoDimensionLabel}`;
                                    } else {
                                        dimensionLabel = `${dimensionData.twoDimensionLabel}`;
                                    }
                                    let percent = params.percent;
                                    return `${dimensionLabel} ${percent}%`;
                                },
                                fontSize: 8
                            },
                            encode: {
                                itemName: 'dimensionLabel',
                                value: 'metricLabel'
                            },
                            datasetIndex: 1
                        }
                    ]
                }
            },
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            },
            oneDimensionSettingMap: new Map,
            customMultiPieConfig: {
                counter: 0,
                colSpanNum: 3,
                defaultColSpanNum: 3,
                defaultChartHeight: 150,
                defaultRadius: 40,
                chartHeight: '150px'
            }
        }
    },
    watch: {
        trackReportSettingId: {
            deep: true,
            handler(newVal) {
                this.queryParams.trackReportSettingId = newVal
                this.convertData.trackReportSettingId = newVal
                this.refresh()
            }
        },
        trackReportSettingJson: {
            deep: true,
            handler(newVal) {
                this.convertData.trackReportSettingJson = newVal
                this.refresh()
            }
        },
    },
    created() {
        this.convertData.trackReportSettingId = this.trackReportSettingId;
        this.convertData.trackReportSettingJson = this.trackReportSettingJson;
        this.queryParams.trackReportSettingId = this.convertData.trackReportSettingId;
        this.queryParams.projectAppId = this.projectAppId;
        this.refresh();
    },
    computed: {
        computeOnePieSwitchLabel() {
            return item => {
                let oneDimensionTitle = item.customDimensionSetting.oneDimensionTitle;
                return `显示 ${oneDimensionTitle} 分组详情`;
            };
        }
    },
    methods: {
        refresh() {
            this.chartData.chartLoadingStatus = false;
            this.chartData.chartOptionList = [];
            // 根据报表设置id获取报表数据
            if (this.convertData.trackReportSettingId) {
                this.getTrackReportData();
            } else {
                if (this.convertData.trackReportSettingJson) {
                    // 通过报表设置进行查询
                    this.getTemporaryTrackReportData(this.convertData.trackReportSettingJson);
                }
            }
        },
        refreshCache() {
            trackEventAnalyseApi.deleteAnalyseCache().then(result => {
                if (result.code === 200) {
                    message.success('缓存已刷新, 正在重新进行报表分析...');
                    this.refresh();
                }
            });
        },
        reset() {
            this.queryParams.startTime = undefined;
            this.queryParams.endTime = undefined;
            this.timePicker.pickerTimeValue = [];
            this.refresh();
        },
        getTrackReportData() {
            trackEventAnalyseApi.analyseTrackEvent(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.reportChartResult = result.data;
                    this.packageChartData()
                }
            })
        },
        getTemporaryTrackReportData(trackReportSettingJson) {
            let obj;
            try {
                obj = JSON.parse(trackReportSettingJson);
            } catch (e) {
                console.error(e);
                message.error('解析报表JSON出错!');
                return;
            }
            obj.projectAppId = this.queryParams.projectAppId;
            trackEventAnalyseApi.temporaryAnalyseTrackEvent(obj).then(result => {
                if (result.code === 200) {
                    this.reportChartResult = result.data;
                    this.packageChartData();
                }
            });
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return
            }
            this.queryParams.startTime = this.timePicker.pickerTimeValue[0];
            this.queryParams.endTime = this.timePicker.pickerTimeValue[1];
            this.refresh()
        },
        async setChartOptionMap(chartTypeOptionMap, dimensionMetricList) {
            return new Promise((resolve, reject) => {
                let map = new Map;
                for (let i = 0; i < dimensionMetricList.length; i++) {
                    let metricSetting = dimensionMetricList[i].metricSetting;
                    let chartType = metricSetting.chartType;
                    let metricTitle = metricSetting.metricTitle;
                    if (chartType !== 'pie') {
                        if (!map.get('common')) {
                            map.set('common', cloneDeep(this.chartData.chartTemplateOption));
                        }
                        chartTypeOptionMap.set('common', map.get('common'));
                    } else {
                        // 是饼图
                        chartTypeOptionMap.set(metricTitle, cloneDeep(this.chartData.pieChartTemplateOption));
                    }
                    
                    if (i === dimensionMetricList.length - 1) {
                        resolve();
                    }
                }
            });
        },
        async setChartOptionSortInfo(chartTypeOptionMap) {
            let optionArr = Array.from(chartTypeOptionMap);
            for (let i = 0; i < optionArr.length; i++) {
            
            }
        },
        async getOneDimensionDataSource(twoDimensionConfigList, oneDimensionTitle) {
            if (!twoDimensionConfigList) {
                return undefined;
            }
            return new Promise((resolve, reject) => {
                twoDimensionConfigList.sort((a, b) => parseInt(a.dsv) - parseInt(b.dsv));
                // 将二维数据放入
                let oneDimensionTempDatasource = {
                    dimensions: ['dimensionLabel', 'metricLabel', 'sortValue'],
                    source: [],
                    chartType: 'line',
                    type: 'chartData',
                    metricTitle: ''
                };
                
                new Promise((resolve, reject) => {
                    this.oneDimensionSettingMap = new Map;
                    let oneDimensionLabelList = [];
                    twoDimensionConfigList.forEach((twoDimensionConfig, twoIndex) => {
                        let twoStartSortValue = parseInt(twoDimensionConfig.ssv);
                        let twoEndSortValue = parseInt(twoDimensionConfig.esv);
                        let index = 0;
                        let showDimensionLabelIndex = 0;
                        
                        if (twoEndSortValue - twoStartSortValue <= 2) {
                            // 被分组的二维很少
                            showDimensionLabelIndex = twoStartSortValue;
                        } else {
                            // 分组有点多，取中位
                            let num = (twoEndSortValue - twoStartSortValue) / 2;
                            showDimensionLabelIndex = (Math.round(num + twoStartSortValue));
                        }
                        for (let j = twoStartSortValue; j <= twoEndSortValue; j++) {
                            let sortValue = twoStartSortValue + index;
                            let label = `${sortValue}_${twoDimensionConfig.dl}`;
                            let data = {
                                oneDimensionLabel: label,
                                twoStartSortValue: twoDimensionConfig.ssv,
                                twoEndSortValue: twoDimensionConfig.esv,
                                showDimensionLabel: twoDimensionConfig.dl,
                                sortValue: sortValue,
                                isShowDimensionLabel: showDimensionLabelIndex === sortValue,
                                oneDimensionTitle: oneDimensionTitle
                            };
                            oneDimensionLabelList.push(data);
                            this.oneDimensionSettingMap.set(sortValue, data);
                            index++;
                            if (twoIndex === twoDimensionConfigList.length - 1 && j === twoEndSortValue) {
                                resolve(oneDimensionLabelList);
                            }
                        }
                    });
                }).then(oneDimensionLabelList => {
                    // 将一维数据放入数据源中
                    oneDimensionLabelList.forEach((oneDimensionData, oneDimensionDataIndex) => {
                        oneDimensionTempDatasource.source.push([JSON.stringify(oneDimensionData), null, oneDimensionData.sortValue, oneDimensionData]);
                        if (oneDimensionDataIndex === oneDimensionLabelList.length - 1) {
                            resolve(oneDimensionTempDatasource);
                        }
                    });
                });
            });
        },
        async packageChartData() {
            if (!this.reportChartResult || !this.reportChartResult.addictionData) {
                message.success('无任何数据!');
                this.chartData.chartLoadingStatus = true;
                return;
            }
            
            let addictionData = this.reportChartResult.addictionData;
            if (!addictionData || !addictionData.metricList) {
                message.success(this.reportChartResult.chartName + '无任何数据!');
                this.chartData.chartLoadingStatus = true;
                return;
            }
            
            let dimensionMetricList = addictionData.metricList;
            let twoDimensionConfigList = addictionData.twoDimensionConfigList;
            let oneDimensionDataSource = await this.getOneDimensionDataSource(twoDimensionConfigList, addictionData.oneDimensionTitle);
            
            let dimensionSetting = dimensionMetricList[0].dimensionSetting;
            // 设置二维维度标签名
            this.chartData.chartTemplateOption.xAxis[0].name = dimensionSetting.dimensionTitle;
            
            let chartTypeOptionMap = new Map;
            await this.setChartOptionMap(chartTypeOptionMap, dimensionMetricList);
            
            let commonDimensionMetricList = dimensionMetricList.filter(t => {
                let metricSetting = t.metricSetting;
                let chartType = metricSetting.chartType;
                return chartType !== 'pie';
            });
            
            let pieDimensionMetricList = dimensionMetricList.filter(t => {
                let metricSetting = t.metricSetting;
                let chartType = metricSetting.chartType;
                return chartType === 'pie';
            });
            
            // 遍历指标集合
            let commonSeriesTemplate = {
                smooth: true,
                encode: { x: 'dimensionLabel', y: 'metricLabel' }
                // xAxisIndex: 0
            };
            commonDimensionMetricList.forEach((dimensionItem, dimensionMetricIndex) => {
                this.setSingleChartOption(dimensionItem, chartTypeOptionMap.get('common'), dimensionMetricIndex,
                    oneDimensionDataSource, commonDimensionMetricList, true, this.chartData.chartOptionList, commonSeriesTemplate);
            });
            
            let pieSeriesTemplate = {
                type: 'pie',
                stillShowZeroSum: true,
                itemStyle: { 'borderRadius': 8 },
                label: { 'show': true, 'position': 'outside' },
                encode: { 'itemName': 'dimensionLabel', 'value': 'metricLabel' }
            };
            pieDimensionMetricList.forEach((dimensionItem, dimensionMetricIndex) => {
                let metricTitle = dimensionItem.metricSetting.metricTitle;
                let singleChartOption = chartTypeOptionMap.get(metricTitle);
                this.setSingleChartOption(dimensionItem, singleChartOption, dimensionMetricIndex,
                    oneDimensionDataSource, pieDimensionMetricList, false, this.chartData.chartOptionList, pieSeriesTemplate);
            });
        },
        setSingleChartOption(dimensionMetricItem, singleChartOption, dimensionMetricIndex,
                             oneDimensionDataSource, dimensionMetricList, isMergeMultiMetric, chartOptionList, seriesTemplate) {
            // 图标数据
            let chartDataListObject = dimensionMetricItem.chartDataList;
            let chartDataKeys = Object.keys(chartDataListObject);
            
            let dimensionSetting = dimensionMetricItem.dimensionSetting;
            // 指标展示类型和指标名
            let chartTypeTemp = dimensionMetricItem.metricSetting.chartType;
            let metricTitle = dimensionMetricItem.metricSetting.metricTitle;
            let cottonCustomConfig = singleChartOption.cottonCustomConfig;
            if (!cottonCustomConfig) {
                cottonCustomConfig = {
                    operateNum: 1,
                    metricSetting: dimensionMetricItem.metricSetting,
                    chartType: chartTypeTemp,
                    isTwoDimension: oneDimensionDataSource !== undefined,
                    twoDimensionPieChartList: [],
                    setSeriesLabel: true
                };
                singleChartOption.cottonCustomConfig = cottonCustomConfig;
            } else {
                if (!cottonCustomConfig.operateNum) cottonCustomConfig.operateNum = 1;
                if (!cottonCustomConfig.metricSetting) cottonCustomConfig.metricSetting = dimensionMetricItem.metricSetting;
                if (!cottonCustomConfig.chartType) cottonCustomConfig.chartType = chartTypeTemp;
                if (!cottonCustomConfig.isTwoDimension) cottonCustomConfig.isTwoDimension = oneDimensionDataSource !== undefined;
                if (!cottonCustomConfig.twoDimensionPieChartList) cottonCustomConfig.twoDimensionPieChartList = [];
            }
            cottonCustomConfig.dimensionConfig = dimensionSetting;
            let setChartTextFunction = cottonCustomConfig.setChartTextFunction;
            
            if (setChartTextFunction) {
                singleChartOption.title.text = setChartTextFunction(singleChartOption, dimensionMetricItem, dimensionMetricIndex);
            } else {
                singleChartOption.title.text = singleChartOption.title.text + ' ' + metricTitle;
            }
            
            // 图表数据源
            let sourceObject = {
                dimensions: ['dimensionLabel', 'metricLabel', 'sortValue'],
                source: [],
                chartType: chartTypeTemp,
                type: 'chartData',
                metricTitle: metricTitle,
                dataSetIndex: dimensionMetricIndex,
                id: `dataId${dimensionMetricIndex}`
            };
            
            // 遍历每一个指标数据，dimensionLabel是维度的排序值
            chartDataKeys.forEach((dimensionSortValue, chartIndex) => {
                let chartData = chartDataListObject[dimensionSortValue];
                let sortValue = parseInt(chartData['sv']);
                let dimensionLabel;
                let oneDimensionSetting = chartData['ods'];
                let labelData;
                let customDimensionSetting;
                let isTwoDimension = oneDimensionDataSource !== undefined;
                if (oneDimensionSetting) {
                    let oneDimensionLabel = oneDimensionSetting['dv'];
                    let oneDimensionSettingMap = this.oneDimensionSettingMap.get(sortValue);
                    let twoEndSortValue = parseInt(oneDimensionSettingMap.twoEndSortValue);
                    labelData = {
                        twoDimensionLabel: chartData['dv'],
                        twoDimensionTitle: dimensionSetting.dimensionTitle,
                        
                        showAxisTick: twoEndSortValue === sortValue,
                        oneDimensionLabel: oneDimensionLabel,
                        oneDimensionTitle: oneDimensionSettingMap.oneDimensionTitle,
                        isTwoDimension: isTwoDimension
                    };
                    customDimensionSetting = {
                        oneDimensionLabel: oneDimensionLabel,
                        oneDimensionTitle: oneDimensionSettingMap.oneDimensionTitle,
                        twoDimensionLabel: chartData['dv'],
                        twoDimensionTitle: dimensionSetting.dimensionTitle
                    };
                } else {
                    labelData = {
                        twoDimensionTitle: dimensionSetting.dimensionTitle,
                        twoDimensionLabel: chartData['dv'],
                        isTwoDimension: isTwoDimension
                    };
                    customDimensionSetting = {
                        twoDimensionLabel: chartData['dv'],
                        twoDimensionTitle: dimensionSetting.dimensionTitle
                    };
                }
                
                if (!cottonCustomConfig.customDimensionSetting) {
                    cottonCustomConfig.customDimensionSetting = customDimensionSetting;
                }
                
                dimensionLabel = JSON.stringify(labelData);
                
                let singleSource = [dimensionLabel, parseFloat(chartData['mv']), sortValue];
                sourceObject.source.push(singleSource);
                
                // 单个指标数据全部遍历完成
                if (chartIndex === chartDataKeys.length - 1) {
                    singleChartOption.dataset.push(sourceObject);
                    singleChartOption.dataset.push({
                        transform: {
                            type: 'sort',
                            config: { dimension: 'sortValue', order: 'asc' }
                        },
                        fromDatasetId: `dataId${dimensionMetricIndex}`,
                        sortedDatasetIndex: dimensionMetricIndex * 2 + 1,
                        chartType: chartTypeTemp,
                        metricTitle: metricTitle
                    });
                    
                    // 所有的指标都遍历完成
                    if (!isMergeMultiMetric) {
                        this.setChartData(isMergeMultiMetric, singleChartOption, oneDimensionDataSource, dimensionMetricList.length, chartOptionList, seriesTemplate);
                    } else {
                        if (dimensionMetricIndex === dimensionMetricList.length - 1) {
                            this.setChartData(isMergeMultiMetric, singleChartOption, oneDimensionDataSource, dimensionMetricList.length, chartOptionList, seriesTemplate);
                        }
                    }
                }
            });
        },
        setChartData(isMergeMultiMetric, charOption, oneDimensionDataSource,
                     oneDimensionDataSourceIndex, chartOptionList, seriesTemplate) {
            new Promise((resolve, reject) => {
                let chartTitle = '';
                
                let sortedDataSourceList = charOption.dataset.filter(t => t.transform);
                if (sortedDataSourceList.length === 0) {
                    resolve(charOption);
                    return;
                }
                
                sortedDataSourceList.forEach((sortedSource, index) => {
                    chartTitle = chartTitle + sortedSource.metricTitle + ' ';
                    if (!isMergeMultiMetric) {
                        charOption.series[0].name = sortedSource.metricTitle;
                    } else {
                        let chartType = sortedSource.chartType;
                        if (index === 0) {
                            let firstSeries = charOption.series[0];
                            firstSeries.name = sortedSource.metricTitle;
                            firstSeries.type = sortedSource.chartType;
                        } else {
                            if (chartType === 'pie') {
                                let series = deepCopy(seriesTemplate);
                                series.name = sortedSource.metricTitle;
                                series.datasetIndex = sortedSource.sortedDatasetIndex;
                                charOption.series.push(series);
                            } else {
                                let series = deepCopy(seriesTemplate);
                                series.id = `seriesId${index}`;
                                series.type = sortedSource.chartType;
                                series.datasetIndex = sortedSource.sortedDatasetIndex;
                                series.name = sortedSource.metricTitle;
                                charOption.series.push(series);
                            }
                        }
                        charOption.legend.data.push({
                            icon: 'circle',
                            name: sortedSource.metricTitle
                        });
                    }
                    
                    if (index === sortedDataSourceList.length - 1) {
                        resolve(charOption);
                    }
                });
            }).then(charOption => {
                let cottonCustomConfig = charOption.cottonCustomConfig;
                if (cottonCustomConfig.operateNum !== 1) {
                    return;
                }
                if (oneDimensionDataSource && isMergeMultiMetric) {
                    this.setOneDimensionChartOption(oneDimensionDataSource, oneDimensionDataSourceIndex, charOption, chartOptionList);
                } else {
                    if (oneDimensionDataSource) {
                        this.setMultiPieChart(charOption);
                    }
                    chartOptionList.push(charOption);
                    this.chartData.chartLoadingStatus = true;
                }
            });
        },
        setOneDimensionChartOption(oneDimensionDataSource, oneDimensionDataSourceIndex, charOption, chartOptionList) {
            oneDimensionDataSource.source.forEach((t, index) => {
                charOption.xAxis[1].data.push(t[0]);
            });
            oneDimensionDataSource.dataSetIndex = oneDimensionDataSourceIndex;
            oneDimensionDataSource.id = `oneDimensionDataId${oneDimensionDataSourceIndex}`;
            
            // 创建排序
            charOption.dataset.push(oneDimensionDataSource);
            charOption.dataset.push({
                transform: {
                    type: 'sort',
                    config: { dimension: 'sortValue', order: 'asc' }
                },
                fromDatasetId: `oneDimensionDataId${oneDimensionDataSourceIndex}`,
                sortedDatasetIndex: oneDimensionDataSourceIndex * 2 + 1,
                chartType: 'line',
                metricTitle: ''
            });
            // 放入series
            charOption.series.push({
                type: 'line',
                smooth: true,
                encode: { x: 'dimensionLabel', y: 'metricLabel' },
                datasetIndex: oneDimensionDataSourceIndex * 2 + 1,
                name: 'oneDimension',
                xAxisIndex: 1
            });
            charOption.cottonCustomConfig.operateNum = charOption.cottonCustomConfig.operateNum + 1;
            chartOptionList.push(charOption);
            this.chartData.chartLoadingStatus = true;
        },
        setMultiPieChart(charOption) {
            let addictionData = this.reportChartResult.addictionData;
            let twoDimensionConfigList = addictionData.twoDimensionConfigList;
            let dimensionSetting = addictionData.metricList[0].dimensionSetting;
            
            let oneDimensionMappingMap = new Map;
            twoDimensionConfigList.forEach(t => {
                oneDimensionMappingMap.set(t.oneDimensionLabel, t);
            });
            
            // 将二维的所有数据切到一维上去
            let twoDimensionSourceList = charOption.dataset.filter(t => !t.transform)[0].source;
            
            let allMetricListMap = new Map;
            twoDimensionSourceList.forEach((source, index) => {
                let dimensionData = JSON.parse(source[0]);
                
                let oneDimensionLabel = dimensionData.oneDimensionLabel;
                let metricChartList = allMetricListMap.get(oneDimensionLabel);
                
                if (!metricChartList) {
                    metricChartList = {};
                }
                
                // 构造数据
                metricChartList[source[2]] = {
                    dimensionValue: dimensionData.twoDimensionLabel,
                    metricValue: source[1],
                    sortValue: source[2]
                };
                allMetricListMap.set(oneDimensionLabel, metricChartList);
                if (index === twoDimensionSourceList.length - 1) {
                    let metricList = [];
                    let list = Array.from(allMetricListMap);
                    list.forEach((item, metricIndex) => {
                        let chartDataList = item[1];
                        metricList.push({
                            dimensionSetting: dimensionSetting,
                            metricSetting: charOption.cottonCustomConfig.metricSetting,
                            chartDataList,
                            dimensionLabel: item[0]
                        });
                        if (metricIndex === list.length - 1) {
                            charOption.cottonCustomConfig.twoDimensionPieChartList = [];
                            metricList.forEach((dimensionItem, dimensionMetricIndex) => {
                                let singleChartOption = cloneDeep(this.chartData.twoDimensionPieChartTemplateOption);
                                singleChartOption.cottonCustomConfig = {
                                    setChartTextFunction: (chartOption, dimensionMetricItem, dimensionMetricIndex) => {
                                        return dimensionMetricItem.dimensionLabel;
                                        // console.log(dimensionMetricItem.dimensionLabel);
                                    }
                                };
                                this.setSingleChartOption(dimensionItem, singleChartOption, dimensionMetricIndex,
                                    undefined, metricList, false, charOption.cottonCustomConfig.twoDimensionPieChartList, {});
                            });
                        }
                    });
                }
            });
        },
        handleChangeMultiPieSize(num, chartOption) {
            this.customMultiPieConfig.colSpanNum = this.customMultiPieConfig.defaultColSpanNum + num;
            this.customMultiPieConfig.chartHeight = `${this.customMultiPieConfig.defaultChartHeight + num * 15}px`;
            let twoDimensionPieChartList = chartOption.cottonCustomConfig.twoDimensionPieChartList;
            twoDimensionPieChartList.forEach(t => {
                t.series[0].radius = this.customMultiPieConfig.defaultRadius + num * 10;
            });
        },
        handleOpenExport() {
            trackReportSettingApi.queryOne({ id: this.trackReportSettingId }).then(result => {
                if (result.code === 200) {
                    let eventId = this.eventId;
                    if (!result.data.tableSetting) {
                        message.error('无报表设置!');
                        return;
                    }
                    let reportSetting = JSON.parse(result.data.tableSetting);
                    let exportConfig = {
                        multiConditionExpress: reportSetting.globalFilterExpress,
                        eventIdList: [this.eventId],
                        projectAppIdList: [this.projectAppId],
                        startTime: this.queryParams.startTime,
                        endTime: this.queryParams.endTime
                    };
                    exportTrackDataApi.createExportTask(exportConfig).then(result => {
                        if (result.code === 200) {
                            let url = window.location.protocol + '//' + window.location.host + '/#/exportTask';
                            let notificationMessage = `任务详情请到 <a href='${url}' target='_blank'>${url}</a> 查看`;
                            notification.success(notificationMessage);
                        }
                    });
                }
            });
        }
    }
});
</script>

<style scoped lang='scss'>

</style>
